import script from "./TicketViewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketViewDialog.vue?vue&type=script&setup=true&lang=js"

import "./TicketViewDialog.vue?vue&type=style&index=0&id=2c87cc16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c87cc16"]])

export default __exports__